import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterBar = ({ 
  filters, 
  onFilterChange,
  onClearFilters 
}) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'yoga', label: 'Yoga' },
    { value: 'hiit', label: 'HIIT' },
    { value: 'strength', label: 'Strength Training' },
    { value: 'cardio', label: 'Cardio' },
    { value: 'pilates', label: 'Pilates' },
    { value: 'cycling', label: 'Cycling' }
  ];

  const difficultyOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' }
  ];

  const timeOptions = [
    { value: 'all', label: 'All Times' },
    { value: 'morning', label: 'Morning (6AM-12PM)' },
    { value: 'afternoon', label: 'Afternoon (12PM-5PM)' },
    { value: 'evening', label: 'Evening (5PM-9PM)' }
  ];

  const instructorOptions = [
    { value: 'all', label: 'All Instructors' },
    { value: 'sarah', label: 'Sarah Johnson' },
    { value: 'mike', label: 'Mike Chen' },
    { value: 'emma', label: 'Emma Rodriguez' },
    { value: 'david', label: 'David Kim' },
    { value: 'lisa', label: 'Lisa Anderson' }
  ];

  const hasActiveFilters = 
    filters?.category !== 'all' || 
    filters?.difficulty !== 'all' || 
    filters?.time !== 'all' || 
    filters?.instructor !== 'all';

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Select
            label="Category"
            options={categoryOptions}
            value={filters?.category}
            onChange={(value) => onFilterChange('category', value)}
          />
          
          <Select
            label="Difficulty"
            options={difficultyOptions}
            value={filters?.difficulty}
            onChange={(value) => onFilterChange('difficulty', value)}
          />
          
          <Select
            label="Time"
            options={timeOptions}
            value={filters?.time}
            onChange={(value) => onFilterChange('time', value)}
          />
          
          <Select
            label="Instructor"
            options={instructorOptions}
            value={filters?.instructor}
            onChange={(value) => onFilterChange('instructor', value)}
            searchable
          />
        </div>

        {hasActiveFilters && (
          <Button
            variant="outline"
            size="default"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
            className="lg:mb-0"
          >
            Clear Filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterBar;